
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_ljpwc_30z5b_5",
  "text-to-copy": "awsui_text-to-copy_ljpwc_30z5b_9",
  "text-to-display": "awsui_text-to-display_ljpwc_30z5b_13"
};
  